// extracted by mini-css-extract-plugin
export var borderRadius = "_a0-4";
export var large = "_a0-3";
export var logoContainer = "_a0-0";
export var nameLogo = "_a0-2";
export var small = "_a0-1";